<template>
    <div class="c-table c-table--translators c-table--responsive">
        <table class="c-table__element">
            <thead>
                <tr>
                    <th></th>
                    <th width="30%">Naam</th>
                    <th class="color-dark-gray">Registerniveau</th>
                    <th>Reviseren</th>
                    <th>Beoordeling</th>
                </tr>
            </thead>
            <tbody>
                <c-row
                    v-for="translator in translators"
                    :translator="translator"
                    :max="max"
                    :key="translator.id + '-translator-row'"
                    v-model="selection"
                ></c-row>
            </tbody>
        </table>
    </div>
</template>

<script>
import CRow from '@components/form/translators/Row';

export default {
    components: { CRow },
    props: {
        translators: {
            type: Array,
            required: true
        },
        value: {
            required: false,
            default: () => []
        },
        max: {
            type: Number,
            default: 1
        }
    },
    watch: {
        selection() {
            this.$emit('input', this.selection);
        },
        value() {
            this.selection = this.value;
        }
    },
    data() {
        return {
            selection: []
        }
    },
    created() {
        this.selection = this.value;
    }
}
</script>
